export default __webpack_public_path__ + "static/media/smartAlarm.37bc0f37.png";